import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { TransitionGroup } from 'intact-vue-next';
import { getClassAndStyleForFixed } from './useFixedColumns';
import { Checkbox } from '../checkbox';
import { Radio } from '../radio';
import { TableCell } from './cell';
import { createElementVNode, className as cx, createFragment } from 'intact-vue-next';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    cols = _this$get.cols,
    data = _this$get.data,
    checkType = _this$get.checkType,
    hasFixedLeft = _this$get.hasFixedLeft,
    checked = _this$get.checked,
    disabled = _this$get.disabled,
    className = _this$get.className,
    merge = _this$get.merge,
    grid = _this$get.grid,
    rowIndex = _this$get.index,
    indeterminate = _this$get.indeterminate,
    allDisabled = _this$get.allDisabled,
    selected = _this$get.selected,
    spreaded = _this$get.spreaded,
    hasChildren = _this$get.hasChildren,
    indent = _this$get.indent,
    key = _this$get.key,
    offsetMap = _this$get.offsetMap,
    draggable = _this$get.draggable,
    draggingKey = _this$get.draggingKey,
    animation = _this$get.animation,
    loaded = _this$get.loaded;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-checked"] = checked, _classNameObj[k + "-selected"] = selected, _classNameObj[k + "-spreaded"] = spreaded, _classNameObj[k + "-dragging"] = draggingKey === key, _classNameObj[className] = className, _classNameObj);
  var getGridItem = function getGridItem(columnIndex) {
    var _grid$rowIndex;
    return ((_grid$rowIndex = grid[rowIndex]) == null ? void 0 : _grid$rowIndex[columnIndex]) || {
      render: true,
      spans: null
    };
  };
  var vNodes = [];
  var pushCheckTypeVNode = function pushCheckTypeVNode(children) {
    var _getGridItem = getGridItem(0),
      render = _getGridItem.render,
      spans = _getGridItem.spans;
    if (!render) return;
    vNodes.push(_$cv('td', _extends({
      'key': '$checktype'
    }, getClassAndStyleForFixed({
      fixed: hasFixedLeft ? 'left' : false,
      className: [k + "-table-check"]
    }, 0, k), spans), children));
  };
  if (checkType === 'checkbox') {
    pushCheckTypeVNode(_$cc(Checkbox, {
      'value': indeterminate ? false : checked,
      'disabled': allDisabled,
      'indeterminate': indeterminate,
      'ev-$change:value': this.onChangeChecked
    }));
  } else if (checkType === 'radio') {
    pushCheckTypeVNode(_$cc(Radio, {
      'value': indeterminate ? false : checked,
      'disabled': allDisabled,
      'ev-$change:value': this.onChangeChecked
    }));
  }
  var columnIndexOffset = checkType !== 'none' ? 1 : 0;
  cols.forEach(function (props, columnIndex) {
    var _getGridItem2 = getGridItem(columnIndex + columnIndexOffset),
      render = _getGridItem2.render,
      spans = _getGridItem2.spans;
    if (!render) return;
    var columnKey = props.key;
    vNodes.push(_$cc(TableCell, {
      'props': props,
      'columnIndex': columnIndex,
      'rowIndex': rowIndex,
      'data': data,
      'loaded': loaded,
      'offset': offsetMap[columnKey],
      'checkType': checkType,
      'indent': indent,
      'grid': grid,
      'colspan': spans ? spans.colspan : undefined,
      'rowspan': spans ? spans.rowspan : undefined,
      'onClickArrow': _this.onClickArrow,
      'hasChildren': hasChildren,
      'key': columnKey
    }, columnKey));
  });
  var rows = animation ? _$cc(TransitionGroup, {
    'name': 'k-fade-expand',
    'move': false,
    'children': vNodes
  }) : createFragment(vNodes, 8);
  /* const rows = vNodes; */

  // for performance, no normalize
  return createElementVNode(2, 'tr', rows, 2, cx(classNameObj), {
    'data-key': key,
    'ev-mouseenter': this.onMouseEnter,
    'ev-mouseleave': this.onMouseLeave,
    'ev-click': this.onClick,
    'ev-dragstart': draggable ? this.onRowDragStart : null,
    'ev-dragover': draggable ? this.onRowDragOver : null,
    'ev-dragend': draggable ? this.onRowDragEnd : null,
    'draggable': draggable ? true : null
  });
}
;